import React from 'react'
import {Link} from 'react-router-dom'
import {ListItem} from './styled'

const Item = props => {
    const {children, to, active, onClick, className} = props
     
    return <ListItem active={active} className={className} onClick={onClick}>
        {to ? <Link to={to}>
            {children}
        </Link> : children}
    </ListItem>
}

export default Item